module.exports = __webpack_public_path__ + "images/assets/ebf7acf185c3b437fbe8edbfd9b616dc.svg";